import React, { Component } from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import { t } from '../../helpers/translation_helper';
import NavBar from '../_partials/NavBar/_NavBar';
import Header from '../_partials/Header/_Header';
import { connect } from 'react-redux';
import { Outlet } from 'react-router-dom';
import MarketPlaceSidebar from './MarketPlaceSidebar';

class MarketPlace extends Component {
  state = {};

  render() {
    return (
      <Container fluid>
        <div id='iedu-layout'>
          <NavBar />
          <div id='page-content'>
            <Header lite={true} heading={t('MarketPlace')} backBtn showCenterSelector={true} showChildSelector={true} />
            <div style={{ display: 'flex' }}>
              <MarketPlaceSidebar />
              <div
                style={{
                  height: 'calc(100vh - 150px)',
                  // overflowY: 'auto',
                  flex: 1,
                }}>
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  defaultLanguage: state.language.defaultLanguage,
});

export default connect(mapStateToProps, null)(MarketPlace);
